<template>
  <div class="promo-code-applied">
    <span
      class="icon"
      :class="isExpired ? 'has-text-danger' : 'has-text-success'"
    >
      <i class="fa fa-tag" />
    </span>
    <span
      v-if="promo.valueType === 'amount'"
      :class="['promo-code-label', { 'has-text-danger': isExpired, 'has-text-weight-bold': !isExpired }]"
    >
      {{ promo.code }} (-{{ promo.value }}€)
    </span>
    <span
      v-else-if="promo.valueType === 'percentage'"
      :class="['promo-code-label', { 'has-text-danger': isExpired, 'has-text-weight-bold': !isExpired }]"
    >
      {{ promo.code }} (-{{ promo.value }}%)
    </span>
    <span
      class="promo-validity"
      :class="{ 'has-text-danger': isExpired }"
    >
      {{ isExpired ? 'Expiré le: ' : 'Valide jusqu\'au: ' }}{{ formatDate(promo.validity_end) }}
    </span>
  </div>
</template>

<script>
export default {
  props: {
    promo: {
      type: Object,
      required: true
    },
    hasFees: {
      type: Boolean,
      required: true
    },
  },
  computed: {
    isExpired() {
      const now = new Date();
      const validityEnd = new Date(this.promo.validity_end);
      return !this.hasFees && now > validityEnd;
    }
  },
  methods: {
    formatDate(date) {
      if (!date) return '';
      const options = {year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit'};
      return new Date(date).toLocaleDateString('fr-FR', options);
    }
  }
};
</script>

<style scoped>
.promo-code-applied {
  display: flex;
  align-items: center;
  margin-top: 1rem;
}

.promo-code-label {
  background-color: #e6ffed;
  border: 1px solid #b4edc3;
  border-radius: 4px;
  padding: 0.5rem;
  margin-left: 0.5rem;
}

.promo-code-label.has-text-danger {
  background-color: #ffe6e6;
  border: 1px solid #edb4b4;
}

.icon {
  font-size: 1.5rem;
}

.promo-validity {
  margin-left: 1rem;
  color: #555;
}

.promo-validity.has-text-danger {
  color: #d9534f;
}
</style>
